import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'
import type { UserAvatarProps } from '../../types/user-avatar'

const avatarVariants = cva(
  'shrink-0 overflow-hidden rounded-full flex items-center justify-center select-none',
  {
    variants: {
      size: {
        xs: 'h-7 w-7',
        sm: 'h-9 w-9',
        lg: 'h-16 w-16',
        xl: 'h-20 w-20',
      },
    },
    defaultVariants: { size: 'sm' },
  },
)

const textVariants = cva(
  "font-medium leading-none",
  {
    variants: {
      size: {
        xs: 'text-[11px]',
        sm: 'text-[14px]',
        lg: 'text-[24px]',
        xl: 'text-[28px]',
      },
    },
    defaultVariants: { size: 'sm' },
  },
)

export function UserAvatar({
  bgColor,
  fgColor,
  initials,
  name,
  appearance = 'themeTinted',
  size = 'sm',
  className,
}: UserAvatarProps) {
  const isThemeTinted = appearance === 'themeTinted'

  return (
    <div
      className={cn(
        avatarVariants({ size }),
        isThemeTinted && 'border border-foreground/10 bg-primary/10 dark:bg-primary/15',
        className,
      )}
      style={isThemeTinted ? undefined : { backgroundColor: bgColor }}
      aria-label={name ?? 'User avatar'}
      role="img"
    >
      <span
        className={cn(textVariants({ size }), isThemeTinted && 'text-foreground/75')}
        style={isThemeTinted ? { fontFamily: "'Geist', sans-serif" } : { color: fgColor, fontFamily: "'Geist', sans-serif" }}
      >
        {initials}
      </span>
    </div>
  )
}
